import { render, staticRenderFns } from "./TrTestSelectGameV2.vue?vue&type=template&id=5f3b4c0e&scoped=true&"
import script from "./TrTestSelectGameV2.vue?vue&type=script&lang=js&"
export * from "./TrTestSelectGameV2.vue?vue&type=script&lang=js&"
import style0 from "./TrTestSelectGameV2.vue?vue&type=style&index=0&id=5f3b4c0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3b4c0e",
  null
  
)

export default component.exports